import { ValidationProblemDetails } from "hoksource";
import { DirectoryComponent } from "../directory-shared/DirectoryComponent";
import { EditStateBase } from "../types/EditStateBase";
import { PaymentTermsConfigurationService } from "./PaymentTermsConfigurationService";
import { PaymentTermsConfiguration } from "../models/entities/payment-terms-configuration";


export class EditController extends DirectoryComponent<{},
EditStateBase<PaymentTermsConfiguration> &
{
}>
{

    constructor(props)
    {
        super(props);
        this.state = {
            input:{
                active:true,
            }
        };
    }



    id:string;
    
    componentDidMount()
    {
        this.id = this.getQueryParam("id");

        
        if(this.id)
        {
                
            var service = new PaymentTermsConfigurationService(this.http);

            service.find(this.id).then(e => {

                this.setState({
                    input:e
                });
            });

        }
    }

    handleSubmit = async (evt:React.FormEvent<HTMLFormElement>)=>
    {

        
        evt.preventDefault();

        this.setState({
            errors:null,
            isSubmitting:true,
        });

        
        try
        {
            // success 
                
            var service = new PaymentTermsConfigurationService(this.http);

            await service.save(this.state.input);

            this.history.goBack();

        }catch(err)
        {


            if(err.status === 400)
            {
                this.setState({errors:(err as ValidationProblemDetails).errors});
            }
        }


        this.setState({isSubmitting:false});
        
        

    }


}
